import FontManager from 'ub/fonts/font-service/manager';

export const NORMAL_WEIGHT = 400;
export const BOLD_WEIGHT = 600;

export const defaultFont = {
  webFonts: FontManager.addedWebFonts,
  family: 'Arial',
  weight: NORMAL_WEIGHT,
  style: 'normal',
  size: '12',
  textStyles: {
    strong: false,
    em: false
  }
};



// WEBPACK FOOTER //
// ./src/fonts/font-picker/form/initial-state.js